import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiMenuHeaderDTO,
  MenuHeaderDTO,
} from "@lib/strapi/dtos/components/menu/menuHeader.dto";
import { LinkService } from "@lib/strapi/services/components/shared/link.service";
import { MenuItemService } from "@lib/strapi/services/components/menu/menuItem.service";
import { getImageProps, ImageProps } from "@lib/image";

export class MenuHeaderService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiMenuHeaderDTO,
  ): Promise<MenuHeaderDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new MenuHeaderDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.link = await LinkService.fromStrapi(locale, strapiData.link);
    dto.menuItems = await Promise.all(
      (strapiData.menuItems ?? []).map(
        async (item) => await MenuItemService.fromStrapi(locale, item),
      ),
    );
    dto.image = getImageProps(strapiData.image);
    return dto;
  }
}
